<template>
  <div>
    <div class="locale-button w-100">
      <locale-button :home="true" />
    </div>
    <div class="content" v-if="!download">
      <content-card>
        <template #header>
          <div class="subtitle">
            <div>{{ t("download_report.generating") }}</div>
          </div>
        </template>
        <template #description>
          <div class="text-center">
            {{ t("download_report.wait") }}
            <img src="./assets/time-spinner-orange.svg" alt="" class="loading mb-1 spinner" />
          </div>
        </template>
      </content-card>
    </div>
    <div class="content" v-if="!isAndroidWeChat">
      <content-card v-if="download">
        <template #header>
          <div class="subtitle">
            <div>{{ t("download_report.ready") }}</div>
          </div>
        </template>
        <template #description>
          <div class="text-center">
            {{ t("download_report.download1") }}
            <span class="view-report fwd-orange" @click="downloadReport">{{ t("download_report.click_here") }}</span
            >{{ " " + t("download_report.download2") }}
          </div>
        </template>
      </content-card>
    </div>
    <div class="content" v-else>
      <div id="android-report">
        <img id="img-report" />
        <div v-if="download" class="save-click-container">
          <img src="./assets/click-icon.svg" alt="" class="click-icon" />
          <div class="instruction-container">
            <div class="instruction fwd-orange">
              {{ t("download_report.save_report") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="printable">
      <report :rec="info.rec" :userProfile="info.userProfile" :vitalSign="info.vitalSign" />
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { newUserManager } from "../../user/company-user-manager.ts";
import CryptoJS from "crypto-js";
import Report from "../home/result/report.vue";
import sendReport from "@/common/send-report";
import LocaleButton from "../sidebar/locale-button.vue";

// whatsapp
// http://localhost:8080/#/report?state=U2FsdGVkX1%2BrkY%2F1Wsc8Ur6m3anJUXfEkSQ4nj5VWKFcKqkD1X19ojWbT3N5fbmGkcJHmG5Pi3o9oAXnuM3Uo1MfKaAGCbJ%2Bw0lqErQyx0E93f3fkveS45QRZOBDi8hnqOIDvrJQbV59VHcDgHaVeD18QawaBS1mJ%2F3S3k4wL8Jdii7RD0SL9bn5T0hlJ7AUSOmw4%2Bv6644CZN7JnbZfTUJUwSTGmlmOAdFUmJnv5Mw3Rdhy563JZYybU%2FqtUuBKUmyNCyvgTD5tW7w5rYmybE3bLs%2F4J8ggT3kvgONR%2F93vmk2tGMpee8urkPCwrW5k
// http://192.168.1.131:8080/#/report?state=U2FsdGVkX1%2BrkY%2F1Wsc8Ur6m3anJUXfEkSQ4nj5VWKFcKqkD1X19ojWbT3N5fbmGkcJHmG5Pi3o9oAXnuM3Uo1MfKaAGCbJ%2Bw0lqErQyx0E93f3fkveS45QRZOBDi8hnqOIDvrJQbV59VHcDgHaVeD18QawaBS1mJ%2F3S3k4wL8Jdii7RD0SL9bn5T0hlJ7AUSOmw4%2Bv6644CZN7JnbZfTUJUwSTGmlmOAdFUmJnv5Mw3Rdhy563JZYybU%2FqtUuBKUmyNCyvgTD5tW7w5rYmybE3bLs%2F4J8ggT3kvgONR%2F93vmk2tGMpee8urkPCwrW5k

export default {
  components: { Report, LocaleButton },
  setup() {
    const { t, locale } = useI18n();
    const route = useRoute();
    var info = {};

    if (Object.keys(route.query).length == 0) {
      const router = useRouter();
      router.push("/");
    } else {
      const query = decodeURIComponent(route.query.state);
      info = JSON.parse(CryptoJS.AES.decrypt(query, "FWD_2025").toString(CryptoJS.enc.Utf8));
    }
    if (info.locale !== locale) {
      locale.value = info.locale;
    }

    var currentUser = newUserManager.currentUser;

    return {
      t,
      locale,
      currentUser,
      info,
    };
  },
  async mounted() {
    this.downloadReport();
  },
  watch: {
    locale() {
      this.downloadReport();
    },
  },
  methods: {
    async downloadReport() {
      // detect if it's an Android device
      this.isAndroidWeChat = /Android/i.test(navigator.userAgent) && /MicroMessenger/i.test(navigator.userAgent);
      this.download = false;
      if (this.isAndroidWeChat) {
        try {
          await sendReport.exportReport(
            (imgReport) => {
              imgReport.id = "img-report";
              imgReport.style.width = "100%";
              const oldImgReport = document.getElementById("img-report");
              oldImgReport.replaceWith(imgReport);
            },
            true,
            this.isAndroidWeChat
          );
          this.download = true;
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          await sendReport.exportReport(_, true);
          this.download = true;
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
  data() {
    return {
      timeout: undefined,
      download: false,
      message: "",
      isAndroidWeChat: true,
    };
  },
};
</script>

<style scoped>
body {
  min-height: none !important;
  max-height: none !important;
}
.loading {
  width: 25px;
  height: 25px;
}

.view-report {
  text-decoration: underline;
  cursor: pointer;
}
.locale-button {
  z-index: 10;
  position: relative;
}
.content {
  z-index: 1;
}
#android-report {
  padding: 30px;
  padding-top: 80px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  position: relative;
}
.save-click-container {
  position: relative;
  top: -30px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.instruction-container {
  background-color: #fae4d3;
  border-radius: 4px;
  padding: 7px 12px;
}
.instruction {
  font-size: 12px;
}
@media (max-width: 767px) {
  .loading {
    width: 15px;
    height: 15px;
  }
  .save-click-container {
    position: relative;
    top: -20px;
  }
  .click-icon {
    width: 30px;
  }
}
</style>
